/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export { ApiConfiguration } from './api-configuration';
export { RequestBuilder } from './request-builder';
export type { StrictHttpResponse } from './strict-http-response';
export { Api } from './api';
export { ProductsServiceApiModule } from './products-service-api.module';
export type { BatchProductItemDto } from './models/batch-product-item-dto';
export type { BatchProductsDto } from './models/batch-products-dto';
export type { DispatchProductsResponseDto } from './models/dispatch-products-response-dto';
export type { ImportProductsDto } from './models/import-products-dto';
export type { ProductDto } from './models/product-dto';
export type { ProductSearchHitDto } from './models/product-search-hit-dto';
export type { SearchProductsResponseDto } from './models/search-products-response-dto';
export type { SearchResponseRequestParamsDto } from './models/search-response-request-params-dto';
export type { SyncProductsDto } from './models/sync-products-dto';
export { BaseService } from './base-service';
export { ProductsServiceAppService } from './services/products-service-app.service';
export { ProductsServiceProductsService } from './services/products-service-products.service';

export type { AppControllerHealthCheck$Params as AppControllerHealthCheck$Params } from './fn/app/app-controller-health-check';
export { appControllerHealthCheck as appControllerHealthCheck } from './fn/app/app-controller-health-check';
export type { ProductsControllerBatch$Params as ProductsControllerBatch$Params } from './fn/products/products-controller-batch';
export { productsControllerBatch as productsControllerBatch } from './fn/products/products-controller-batch';
export type { ProductsControllerImport$Params as ProductsControllerImport$Params } from './fn/products/products-controller-import';
export { productsControllerImport as productsControllerImport } from './fn/products/products-controller-import';
export type { ProductsControllerSearch$Params as ProductsControllerSearch$Params } from './fn/products/products-controller-search';
export { productsControllerSearch as productsControllerSearch } from './fn/products/products-controller-search';
export type { ProductsControllerSync$Params as ProductsControllerSync$Params } from './fn/products/products-controller-sync';
export { productsControllerSync as productsControllerSync } from './fn/products/products-controller-sync';
